module.exports = __webpack_public_path__ + "img/public/SiteIcons/Show-down-arrow.svg?4da991c0";